var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ding-auth-sty" }, [
    _c("h1", { staticClass: "font-red" }, [_vm._v("选择认证方式")]),
    _c(
      "div",
      { staticClass: "auth-content" },
      [
        _c("h3", { staticClass: "titleII" }, [
          _c("span", { staticClass: "title-icon" }),
          _vm.loginInfo.corpAuthed != 1
            ? _c("span", [
                _vm._v(
                  "当前认证企业：" + _vm._s(_vm.loginInfo.dingTalkCorpName)
                )
              ])
            : _c("span", [_vm._v("个人实名认证")])
        ]),
        _c("div", { staticClass: "auth-type-btns" }, [
          _c(
            "div",
            {
              class: {
                "auth-fast": true,
                "check-type": _vm.authType == _vm.typeOptions.dingBand
              },
              on: {
                click: function($event) {
                  _vm.authType = _vm.typeOptions.dingBand
                }
              }
            },
            [
              _vm._m(0),
              _c("img", {
                attrs: { src: "/images/icon/dingIcon1.png", alt: "钉钉" }
              })
            ]
          )
        ]),
        _c(
          "el-button",
          {
            staticClass: "auth-band",
            attrs: { type: "primary" },
            on: { click: _vm.bandAuthBy }
          },
          [
            _vm._v(
              _vm._s(
                "立即" +
                  (_vm.authType == _vm.typeOptions.dingBand ? "认证" : "绑定")
              )
            )
          ]
        ),
        _c(
          "p",
          {
            staticStyle: { "text-align": "center", margin: "15px 0 0 156px" },
            on: {
              click: function($event) {
                _vm.authType = _vm.typeOptions.saasBand
                _vm.bandAuthBy()
              }
            }
          },
          [
            _vm._v("\n      已有君子签账号？ "),
            _c("span", { staticStyle: { color: "#ec1c1c" } }, [
              _vm._v("立即绑定>>")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h1", [_vm._v("钉钉快速认证")]),
      _c("span", { staticClass: "font-red" }, [_vm._v("2分钟极速认证")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a6a58f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a6a58f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/dingTalkAuth.vue
// module id = 4pBj
// module chunks = 252